import { useEffect } from 'react'
import { useHistory } from 'react-router'
import { logoutUser } from '../../Features/Auth/authSlice'
import { resetAction } from '../../Features/Search/searchSlice'
import { useAppDispatch } from '../../Store'

const FirstStep = () => {
  const dispatch = useAppDispatch()
  const history = useHistory()

  useEffect(() => {
    dispatch(resetAction())
    dispatch(logoutUser()).then(() => history.push('/'))
  }, [dispatch, history])

  return <></>
}

export default FirstStep